var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnGolden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 395,
    height: 1283,
    viewBox: "0 0 395 1283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    width: 395,
    height: 1283,
    transform: "translate(1107 -5)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    width: 708.38,
    height: 2508.38,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    transform: "translate(-1107 5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    transform: "translate(1129 -728.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1800.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1780.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1760.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1740.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1720.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1700.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1680.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1660.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1640.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1620.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1600.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1580.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1560.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1540.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1520.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1500.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1480.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1460.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1440.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1420.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1400.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1380.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1360.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1340.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1320.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1300.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1280.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1260.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1240.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1220.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1200.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1180.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1160.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1140.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1120.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1100.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1080.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1060.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1040.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1020.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 1000.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 980.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 960.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 940.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 920.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 900.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 880.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 860.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 840.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 820.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 800.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 780.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 760.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 740.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 720.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 700.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 680.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 660.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 640.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 620.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 600.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 580.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 560.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 540.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 520.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 500.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 480.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 460.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 440.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 420.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 400.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 380.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 360.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 340.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 320.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 300.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 280.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 260.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 240.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 220.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 200.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 180.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 160.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 140.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 120.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 100.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 80.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 60.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 40.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 20.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    x1: 707.673,
    y2: 707.673,
    transform: "translate(0.354 0.353)",
    fill: "none",
    stroke: "#d6cbb0",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnGolden);
export default __webpack_public_path__ + "static/media/column_golden.79fbba43c217a8ea1c289eeb20019121.svg";
export { ForwardRef as ReactComponent };